<template>
  <div class="password-dialog" v-show="visible">
    <div class="dialog-overlay" @click="closeDialog"></div>
    <div class="dialog-container">
      <div class="dialog-header">
        <h3>修改密码</h3>
        <button class="close-btn" @click="closeDialog">×</button>
      </div>
      <div class="dialog-body">
        <form @submit.prevent="submitForm">
          <div class="form-group">
            <label for="oldPassword">当前密码</label>
            <input
              type="password"
              id="oldPassword"
              v-model="form.oldPassword"
              @blur="validateField('oldPassword')"
              @focus="handleFocus"
              :class="{ 'is-invalid': errors.oldPassword }"
              class="input-field"
            />
            <div class="error-message" v-if="errors.oldPassword">
              {{ errors.oldPassword }}
            </div>
          </div>

          <div class="form-group">
            <label for="newPassword">新密码</label>
            <input
              type="password"
              id="newPassword"
              v-model="form.newPassword"
              @blur="validateField('newPassword')"
              @focus="handleFocus"
              :class="{ 'is-invalid': errors.newPassword }"
              class="input-field"
            />
            <div class="error-message" v-if="errors.newPassword">
              {{ errors.newPassword }}
            </div>
          </div>

          <div class="form-group">
            <label for="confirmPassword">确认新密码</label>
            <input
              type="password"
              id="confirmPassword"
              v-model="form.confirmPassword"
              @blur="validateField('confirmPassword')"
              @focus="handleFocus"
              :class="{ 'is-invalid': errors.confirmPassword }"
              class="input-field"
            />
            <div class="error-message" v-if="errors.confirmPassword">
              {{ errors.confirmPassword }}
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="cancel-btn" @click="closeDialog">
              取消
            </button>
            <button type="submit" class="submit-btn" :disabled="isSubmitting">
              {{ isSubmitting ? "处理中..." : "确认修改" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
//import axios from "axios";

export default {
  name: "PasswordDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      errors: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      isSubmitting: false,
    };
  },
  methods: {
    handleFocus(event) {
      event.target.style.borderColor = "#007BFF";
    },
    closeDialog() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    validateField(field) {
      const input = document.getElementById(field);
      if (input) input.style.borderColor = "#DCDFE6";
      if (field === "oldPassword" && !this.form.oldPassword) {
        this.errors.oldPassword = "请输入当前密码";
      } else if (field === "newPassword") {
        if (!this.form.newPassword) {
          this.errors.newPassword = "请输入新密码";
        } else if (this.form.newPassword.length < 6) {
          this.errors.newPassword = "密码长度不能少于6位";
        } else {
          this.errors.newPassword = "";
        }
      } else if (field === "confirmPassword") {
        if (!this.form.confirmPassword) {
          this.errors.confirmPassword = "请确认新密码";
        } else if (this.form.confirmPassword !== this.form.newPassword) {
          this.errors.confirmPassword = "两次输入的密码不一致";
        } else {
          this.errors.confirmPassword = "";
        }
      }
    },
    validateForm() {
      this.validateField("oldPassword");
      this.validateField("newPassword");
      this.validateField("confirmPassword");

      return (
        !this.errors.oldPassword &&
        !this.errors.newPassword &&
        !this.errors.confirmPassword
      );
    },
    async submitForm() {
      if (!this.validateForm()) return;
      if (this.form.newPassword !== this.form.confirmPassword) {
        this.$message.error("新密码和确认新密码不一致");
        return;
      }
      this.isSubmitting = true;
      try {
        // 从store中获取工号
        const userNumber = this.$store.getters['user/getUserNumber'];
        const requestData = {
          oldPassword: this.form.oldPassword,
          newPassword: this.form.newPassword,
          number: userNumber, // 添加工号参数
        };

        // 使用this.$http.post方式发送请求，使用与项目其他员工接口一致的/staff前缀
        const response = await this.$http
          .post("/updatePassword", requestData, {
            withCredentials: true,
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Content-Type": "application/json",
            },
          })
          .catch((error) => {
            console.log("===== 密码更新请求错误详情 =====");
            console.log("请求数据:", requestData);
            throw error;
          });
        console.log("response:", response);
        console.log("response.status:", response.status);
        console.log("response.data:", response.data);
        // 处理响应
        if (response && response.status === 200) {
          // 检查响应数据类型，支持两种格式：
          // 1. 直接返回成功字符串（如"密码更新成功"）
          // 2. 返回包含code和message的对象格式
          if (
            typeof response.data === "string" &&
            response.data.includes("密码更新成功")
          ) {
            this.$message.success(response.data);
            this.$emit("success");
            this.resetForm();
            this.closeDialog();
          } else if (response.data && String(response.data.code) === "200") {
            this.$message.success(response.data.message || "密码更新成功");
            this.$emit("success");
            this.resetForm();
            this.closeDialog();
          } else {
            this.$message.error(
              "密码更新失败: " +
                (response.data.message || response.data || "未知错误")
            );
          }
        } else {
          this.$message.error("密码更新失败: 服务器响应异常");
        }
      } catch (error) {
        if (error.response) {
          // 处理HTTP错误响应
          switch (error.response.status) {
            case 400:
              this.$message.error("请求参数错误");
              break;
            case 401:
              this.$message.error("当前密码错误");
              this.errors.oldPassword = "当前密码不正确";
              break;
            case 403:
              this.$message.error("没有权限修改密码");
              break;
            default:
              this.$message.error(
                "服务器错误: " + (error.response.data.message || "未知错误")
              );
          }
        } else if (error.code === "ECONNABORTED") {
          this.$message.error("请求超时，请检查网络连接");
        } else {
          this.$message.error("网络错误: " + error.message);
        }
      } finally {
        this.isSubmitting = false;
      }

      // 模拟API调用
      setTimeout(() => {
        this.isSubmitting = false;
        this.$emit("success");
        this.resetForm();
      }, 1500);
    },
    resetForm() {
      this.form = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
    },
  },
};
</script>

<style scoped>
.password-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.dialog-container {
  position: relative;
  width: 400px;
  max-width: 90%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  padding: 0 20px;
}

.dialog-header {
  padding: 16px 24px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #666;
}

.dialog-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.input-field {
  width: 100%;
  padding: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
}

.input-field:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
}

.error-message {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 5px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  padding: 8px 16px;
  background: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn {
  padding: 8px 16px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn:disabled {
  background: #c0c4cc;
  cursor: not-allowed;
}
</style>
